import React, { useState, useEffect } from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions.css';
import { addRouteForPoc } from './functions/add_route_for_poc.function';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import { notify } from '../../common/functions/react-toastify.function';
import { decodeGeometry } from '../../common/functions/decode_geometry_to_geojson.function';
import MapWithDirections from './leasing_deployment_map_section.component';
import PocHeaderComponent from './poc_header.component';
import { Box, Typography, TextField, Button, Popper, Grid } from '@mui/material';
import {
  getRoutesForPoc,
  createLeasing,
  getOneNearbySites,
} from './functions/get_routes_for_poc.function';
import LeasingDeploymentMapWithDirections from './leasing_deployment_map_section.component';
import * as turf from '@turf/turf';
import expandButton from '../../Assets/AlertIcon/Locked Routes.svg';
import { MianNavBarLeft } from '../../common/components/main_navBar_left.component';
import { useNavigate } from 'react-router-dom';
import SideNavPOC from './sideNavPOC/SideNavPOC';
import AltRouteIcon from '@mui/icons-material/AltRoute';

const PocLeasingDeploymentMainComponent = () => {
  // { start_location, end_location, geoJSON, length }
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [routeName, setRouteName] = useState('');
  const [selectedRouteAdditional, setSelectedRouteAdditional] = useState(null);
  const [totalRouteCost, setTotalRouteCost] = useState(null);
  const [geoJson, setgeoJson] = useState([]);
  const [routeSelection, setRouteSelection] = useState(false);
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const [selectedNav, setSelectedNav] = useState(null);
  const [mapMarkers, setMapMarkers] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [removeMarkersSubRoute, setRemoveMarkersSubRoute] = useState(false);
  const [submitAdditional, setSubmitAdditional] = useState(false);
  const [isToggled, setIsToggled] = useState(false); // State for the toggle button
  const [strArray, setStrArray] = useState(['', '']);
  const [sitesAndRoutes, setSitesAndRoutes] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState();
  const handleLockRoute = async () => {
    let pocAddRouteObjWithGeoJson = {};
    setSelectedRoute(selectedRoute);
    if (selectedRoute) {
      if (!isToggled) {
        let geoData = selectedRoute.geoJSON
          ? selectedRoute.geoJSON.coordinates
          : decodeGeometry(selectedRoute?.geometry);
        let startLoc = selectedRoute.start ? selectedRoute.start : geoData[0];
        let endLoc = selectedRoute.end ? selectedRoute.end : geoData[geoData.length - 1];
        pocAddRouteObjWithGeoJson = {
          start_location: startLoc,
          end_location: endLoc,
          length: selectedRoute.distance,
          geoJSON: {
            type: 'LineString',
            coordinates: geoData,
          },
          type: 'LEASING',
          site_id: selectedRoute.site_id,
          routeName: routeName,
        };
      } else {
        let endLoc = selectedRoute.end ? selectedRoute.end : geoData[geoData.length - 1];
        let site = await getOneNearbySites(endLoc.split(',')[0], endLoc.split(',')[1]);
        let endLocation = `${site[0].Long},${site[0].Lat}`;
        selectedRoute.geoJSON.coordinates.push([site[0].Long, site[0].Lat]);
        const lineString = turf.lineString(selectedRoute.geoJSON.coordinates);
        let distance = turf.length(lineString, { units: 'meters' }).toFixed(3);

        let geoData = selectedRoute.geoJSON
          ? selectedRoute.geoJSON.coordinates
          : decodeGeometry(selectedRoute?.geometry);
        let startLoc = selectedRoute.start ? selectedRoute.start : geoData[0];
        pocAddRouteObjWithGeoJson = {
          start_location: startLoc,
          end_location: endLocation,
          length: distance,
          geoJSON: {
            type: 'LineString',
            coordinates: geoData,
          },
          type: 'LEASING',
          site_id: site[0].site_id,
          routeName: routeName,
        };
        console.log('pocAddRouteObjWithGeoJson==>', pocAddRouteObjWithGeoJson);
      }
      try {
        showBackdrop();
        const resp = await addRouteForPoc(pocAddRouteObjWithGeoJson);
        resp?.response && notify('success', 'Permissions Assigned Successfully');
        hideBackdrop();
        fetchRoutes();
      } catch (err) {
        notify('error', err?.response?.data?.message || err.message || 'Something went wrong');
        hideBackdrop();
      }
    } else {
      notify('error', 'Please Lock Route first');
      console.log('No route selected');
    }
  };
  const handleTabSelection = (tabValue) => {
    setTabValue(tabValue);
    sessionStorage.setItem('selectedTab', tabValue);
    // handleDrawerClose();
    navigate('/fibers');
  };

  useEffect(() => {
    fetchRoutes();
  }, [submitAdditional]);
  useEffect(() => {
    createLeasing(sitesAndRoutes);
  }, [sitesAndRoutes]);

  const fetchRoutes = async () => {
    try {
      let routesData = await getRoutesForPoc();
      setRoutes(routesData); // Save the fetched routes
    } catch (error) {
      console.error('Error fetching routes:', error);
    }
  };
  const cancelAllRoutes = () => {
    setStrArray([]);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleToggle = () => {
    setIsToggled((prev) => !prev); // Toggle the button state
  };
  return (
    <>
      <PocHeaderComponent
        handleLockRoute={handleLockRoute}
        selectRoute={selectedRoute}
        totalRouteCost={totalRouteCost}
        setRouteName={setRouteName}
        routeName={routeName}
        cancelAllRoutes={cancelAllRoutes}
        selectedRouteAdditional={selectedRouteAdditional}
        routeSelection={routeSelection}
        setRouteSelection={setRouteSelection}
        mapMarkers={mapMarkers}
        setMapMarkers={setMapMarkers}
        setRemoveMarkersSubRoute={setRemoveMarkersSubRoute}
        submitAdditional={submitAdditional}
        setSubmitAdditional={setSubmitAdditional}
        isToggled={isToggled}
        setIsToggled={setIsToggled}
      />

      {open !== true && (
        <>
          {/* For left Bar */}
          <Grid container>
            <Grid item xs={0.5}>
              {' '}
            </Grid>
            <Grid item xs={11.5}>
              <Box
                sx={{
                  position: 'absolute',
                  top: '40%',
                  // left: '78px',
                  left: '3.8%',
                  zIndex: 999,
                  cursor: 'pointer',
                }}
                onClick={handleDrawerOpen}
              >
                <img alt="" src={expandButton} style={{ width: '43px', height: '152px' }} />
              </Box>
              {/* For left Bar */}
            </Grid>
          </Grid>
        </>
      )}

      {/* <LeasingDeploymentMapWithDirections setSelectedRoute={setSelectedRoute} selectedRoute={selectedRoute} setStrArray={setStrArray} strArray={strArray}
        selectedRouteAdditional={selectedRouteAdditional} setSelectedRouteAdditional={setSelectedRouteAdditional}
        setTotalRouteCost={setTotalRouteCost} routeSelection={routeSelection} setRouteSelection={setRouteSelection}
        mapMarkers={mapMarkers} setMapMarkers={setMapMarkers} routes={routes}
        removeMarkersSubRoute={removeMarkersSubRoute} setRemoveMarkersSubRoute={setRemoveMarkersSubRoute}
        submitAdditional={submitAdditional} setSubmitAdditional={setSubmitAdditional}
        isToggled={isToggled} sitesAndRoutes={sitesAndRoutes} setSitesAndRoutes={setSitesAndRoutes}
      /> */}

      <Grid container>
        <Grid
          item
          xs={0.5}
          borderRight={'1px solid #ccc'}
          sx={{
            height: 'auto',
            // display: 'flex',
            // flexDirection: 'column',
            alignItems: 'center',
            // justifyContent: 'flex-end', // Align content at the bottom
          }}
        >
          <MianNavBarLeft handleTabSelection={handleTabSelection} />
        </Grid>
        <Grid item xs={11.5}>
          <Box sx={{ flexGrow: 1, p: 0 }}>
            <Grid container spacing={0}>
              {open === true && (
                <Grid
                  className={`alert_notification_grid ${open ? 'open_alert_drawer' : 'close_alert_drawer'} `}
                >
                  <div className="alerts_main">
                    <div className="alerts_header">
                      <div className="alerts_title_icon">
                        {/* <img alt='' src={alert} /> */}
                        {/* <AltRouteIcon /> */}
                        <AltRouteIcon sx={{ color: '#BD1D23' }} />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            letterSpacing: '2px',

                            background: 'linear-gradient(90deg, #BD1D23, #FF5733)',
                            WebkitBackgroundClip: 'text', // Ensures gradient is clipped to text
                            WebkitTextFillColor: 'transparent', // Ensures background shows through text
                            animation: 'gradientMove 3s ease-in-out infinite',
                          }}
                        >
                          Locked Routes{' '}
                        </Typography>
                      </div>
                      <button className="crossButton" onClick={handleDrawerClose}>
                        <svg
                          width="10"
                          height="10"
                          style={{ paddingTop: '5px' }}
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.77778 5.9979L11.6352 2.14181C12.1216 1.6556 12.1216 0.850855 11.6352 0.364652C11.1489 -0.121551 10.3438 -0.121551 9.85745 0.364652L6 4.22075L2.14255 0.364652C1.65618 -0.121551 0.851153 -0.121551 0.36478 0.364652C-0.121593 0.850855 -0.121593 1.6556 0.36478 2.14181L4.22222 5.9979L0.36478 9.854C-0.121593 10.3402 -0.121593 11.145 0.36478 11.6312C0.616353 11.8826 0.93501 12 1.25366 12C1.57232 12 1.89098 11.8826 2.14255 11.6312L6 7.77506L9.85745 11.6312C10.109 11.8826 10.4277 12 10.7463 12C11.065 12 11.3836 11.8826 11.6352 11.6312C12.1216 11.145 12.1216 10.3402 11.6352 9.854L7.77778 5.9979Z"
                            fill="#BD1D23"
                          />
                        </svg>
                      </button>
                    </div>
                    {/* <ActiveAlarmsCard data={data} handleReset={handleReset} handleApplyChanges={handleApplyChanges} value={valueTab} loading={loading} totalAlarms={totalAlarms} setTotalAlarms={setTotalAlarms} setSelectedAlarm={setSelectedAlarm} setFiltersValue={setFiltersValue} filtersValue={filtersValue} setRing={setRing} setCity={setCity} setRegion={setRegion} alarmType={alramType} /> */}
                    <SideNavPOC routes={routes} setSelectedNav={setSelectedNav} />
                  </div>
                </Grid>
              )}
              <div
                className={`alert_notification_grid ${open ? 'open_alert_content' : 'close_alert_content'} `}
              >
                <LeasingDeploymentMapWithDirections
                  setSelectedRoute={setSelectedRoute}
                  setSelectedNav={setSelectedNav}
                  selectedNav={selectedNav}
                  selectedRoute={selectedRoute}
                  setStrArray={setStrArray}
                  strArray={strArray}
                  selectedRouteAdditional={selectedRouteAdditional}
                  setRouteName={setRouteName}
                  routeName={routeName}
                  setSelectedRouteAdditional={setSelectedRouteAdditional}
                  setTotalRouteCost={setTotalRouteCost}
                  routeSelection={routeSelection}
                  setRouteSelection={setRouteSelection}
                  cancelAllRoutes={cancelAllRoutes}
                  mapMarkers={mapMarkers}
                  setMapMarkers={setMapMarkers}
                  routes={routes}
                  handleToggle={handleToggle}
                  removeMarkersSubRoute={removeMarkersSubRoute}
                  setRemoveMarkersSubRoute={setRemoveMarkersSubRoute}
                  submitAdditional={submitAdditional}
                  setSubmitAdditional={setSubmitAdditional}
                  isToggled={isToggled}
                  handleLockRoute={handleLockRoute}
                />
              </div>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default PocLeasingDeploymentMainComponent;
